import type { LineTitleRules } from '../city/CityConfig'
import type { SchemaLine } from '../schema/types'

/**
 * The line view's title for `line`, before i18n: its name, and whether it
 * reads "<name> line". A city decides by line type (`CityConfig.lineTitles`):
 * London says "Bakerloo line" but "DLR"; New York leads with the route
 * bullet, because route names repeat ("2 · 7 Avenue Express",
 * "3 · 7 Avenue Express") — unless the name already carries it
 * ("AirTrain JFK — Jamaica").
 */
export function lineTitleParts(
  line: SchemaLine,
  rules: LineTitleRules,
): { readonly name: string; readonly takesSuffix: boolean } {
  const base = line.localName ?? line.id
  const short = line.shortLocalName
  const prefixed =
    rules.shortNameTypes.includes(line.type) &&
    short !== undefined &&
    short !== '' &&
    !base.includes(short)
  return {
    name: prefixed ? `${short} · ${base}` : base,
    takesSuffix: rules.lineSuffixTypes.includes(line.type),
  }
}
